import { openAction } from "./index.js";

export const competitionPlanOneGet = id => openAction(`/competition/plan/one/${id}`);
export const competitionPlanOneByClientAndSlugGet = (clientNumber, slug) => openAction(`/competition/plan/one-by-client-slug/${clientNumber}/${slug}`);
export const competitionEntriesByPlanGet = (id, category = "all") => openAction(`/competition/entries-by-plan/${id}?category=${category}`);
export const competitionLeaderboardGet = (id, category = "all", event = "all") => openAction(
  `/competition/leaderboard/${id}?category=${category}&event=${event}&clientDate=${(new Date()).toISOString()}`,
);
